import { useNavigate, useLocation } from 'react-router-dom'
import { t } from '@lingui/core/macro'
import { useCurrentOrg } from '@/features/auth/hooks/useOrg'

export function OrgSwitcher() {
  const { currentOrg, orgs, switchOrg } = useCurrentOrg()
  const navigate = useNavigate()
  const location = useLocation()

  if (orgs.length <= 1) return null

  return (
    <select
      value={currentOrg?._id ?? ''}
      onChange={(e) => {
        const org = orgs.find((o) => o._id === e.target.value)
        if (org) {
          switchOrg(org)
          // If on a detail or edit page, the expense ID belongs to the previous org.
          // Navigate to the list so the stale ID doesn't trigger a 404 on the new org.
          if (/^\/expenses\/\w/.test(location.pathname)) {
            navigate('/expenses')
          }
        }
      }}
      aria-label={t`Select organization`}
      className="border-input bg-background focus:ring-ring/50 h-9 min-w-0 shrink truncate rounded-md border pr-7 pl-2 text-base outline-none focus:ring-2"
    >
      {orgs.map((org) => (
        <option key={org._id} value={org._id}>
          {org.orgName}
        </option>
      ))}
    </select>
  )
}
